// frontend/src/components/pacientes/CambioEstadoPaciente.jsx
import React, { useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography
} from '@mui/material';
import pacienteService from '../../services/pacienteService';

const CambioEstadoPaciente = ({ open, onClose, paciente, onEstadoChanged }) => {
  const [formData, setFormData] = useState({
    estado_nuevo: paciente?.estado || 'Activo',
    motivo: '',
    observaciones: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.motivo) {
      setError('El motivo del cambio es obligatorio');
      return;
    }
    
    try {
      setLoading(true);
      await pacienteService.cambiarEstado(paciente.id, formData.estado_nuevo, formData.motivo, formData.observaciones);
      onEstadoChanged(formData.estado_nuevo);
      onClose();
    } catch (error) {
      console.error('Error al cambiar estado:', error);
      setError('Error al cambiar el estado del paciente. Por favor, intente nuevamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Cambiar Estado del Paciente</DialogTitle>
      <DialogContent>
        <Typography variant="body2" gutterBottom>
          Paciente: {paciente?.nombres} {paciente?.apellidos}
        </Typography>
        <Typography variant="body2" gutterBottom>
          Estado actual: <strong>{paciente?.estado}</strong>
        </Typography>
        
        <form onSubmit={handleSubmit}>
          <FormControl fullWidth margin="normal" required>
            <InputLabel>Nuevo Estado</InputLabel>
            <Select
              name="estado_nuevo"
              value={formData.estado_nuevo}
              onChange={handleChange}
              label="Nuevo Estado"
            >
              <MenuItem value="Activo">Activo</MenuItem>
              <MenuItem value="Inactivo">Inactivo</MenuItem>
              <MenuItem value="De alta">De alta</MenuItem>
              <MenuItem value="Pausa">Pausa</MenuItem>
            </Select>
          </FormControl>
          
          <TextField
            name="motivo"
            label="Motivo del cambio"
            value={formData.motivo}
            onChange={handleChange}
            fullWidth
            margin="normal"
            required
            error={!!error && !formData.motivo}
            helperText={!formData.motivo && !!error ? 'El motivo es obligatorio' : ''}
          />
          
          <TextField
            name="observaciones"
            label="Observaciones adicionales"
            value={formData.observaciones}
            onChange={handleChange}
            fullWidth
            margin="normal"
            multiline
            rows={4}
          />
        </form>
        
        {error && <FormHelperText error>{error}</FormHelperText>}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button 
          onClick={handleSubmit}
          variant="contained" 
          color="primary"
          disabled={loading || !formData.motivo}
        >
          {loading ? 'Guardando...' : 'Guardar Cambio'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CambioEstadoPaciente;